<template>
  <div>
    <div class="h-40 flex a-center j-center">
      <span class="fs-16 bold">选择商品</span>
    </div>
    <div style="min-height: 400px">
      <div class="flex a-center h-60 p-l-25">
        <class-choose-widget :gutter="10" :srcType="11" @dataChange="onClassGroupChange" leftPlaceholder="商品分类"
                             :obj-data="objChange"
                             rightPlaceholder="商品分组"
                             style="width: 300px;">

        </class-choose-widget>

        <Input class="m-l-15" placeholder="商品名称" style="width: 240px" v-model="title"/>
        <Button @click="onSearchClick" class="m-l-15">搜索</Button>

      </div>
      <div class="m-h-25 ">
        <RadioGroup @on-change="selectionsChange" class="w-full" v-if="!multiSelect"
                    v-model="selectId">
          <Table :columns="columns" :data="dataList" :height="tableHeight"
                 @on-row-click="rowClick">
            <template slot="selectColumns" slot-scope="{ row }">
              <div class="flex a-center j-center h-full selModal" style="height: 48px">
                <Radio :key="row.id" :label="row.id">
                  <span></span>
                </Radio>
              </div>
            </template>
          </Table>
        </RadioGroup>
        <CheckboxGroup @on-change="selectionsChange" class="w-full" v-if="multiSelect"
                       v-model="selections">
          <Table :columns="columns" :data="dataList" :height="tableHeight"
                 @on-row-click="rowClick">
            <template slot="selectColumns" slot-scope="{ row }">
              <div class="flex a-center j-center h-full selModal" style="height: 48px">
                <Checkbox :key="row.id" :label="row.id">
                  <span></span>
                </Checkbox>
              </div>
            </template>
          </Table>
        </CheckboxGroup>
        <div style="padding-top: 10px">
          <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
                :show-total="true"
                :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
                show-sizer></Page>
        </div>
      </div>
    </div>
    <div class="h-50 flex a-top j-center">
      <Button @click="onCancelClick" class="m-r-15" style="width: 100px">取消</Button>
      <Button @click="onOkClick" class="m-l-15" style="width: 100px" type="primary">确定</Button>
    </div>
  </div>
</template>

<script>
import ClassChooseWidget from '../common/ClassChooseWidget'
import mixin from '../../config/mixinfile'
import {mapActions} from 'vuex'

export default {
  name: 'ProductChooseWidget',
  components: {ClassChooseWidget},
  mixins: [mixin.mixin],
  props: {
    open: Boolean,
    multiSelect: {                                          // 是否多选
      type: Boolean,
      default: false,
    },
    selectedRows: {                                         // 多选的已选id
      type: Array,
      default: () => [],
    },
  },
  watch: {
    open: {
      handler (newValue) {
        if (newValue) {
          this.tablePage.currentPage = 1
          this.title = ''
          this.selectId = 0
          this.selectName = ''
          this.objChange = {                               //分类分组帅选
            classId: 0,
            groupId: 0,
            linkurl: ''
          }
          this.dataList = []
          if (this.multiSelect) {
            this.selections = this.selectedRows.map(res => {
              this.selectionMaps.set(res.id, res)
              return res.id
            })
          }
          this.onGetGoods()
        } else {
          this.selections = []
          this.selectionMaps.clear()
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      selectId: 0,
      selectName: '',
      title: '',
      tableHeight: 520,
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: ''
      },
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 30,
      },
      columns: [
        {
          title: '选择',
          align: 'center',
          slot: 'selectColumns',
          width: 80,
        },
        {
          title: '商品分类',
          key: 'categoryName',
          width: 120,
          tooltip: true
        }, {
          title: '商品分组',
          key: 'groupName',
          width: 120,
          tooltip: true
        },
        {
          title: '商品名称',
          key: 'name',
          width: 140,
          tooltip: true
        }, {
          title: '商品链接',
          key: 'url',
          align: 'center',
          tooltip: true,
        }
      ],
      dataList: [],
      selections: [],                                    //选择Id集合
      selectionMaps: new Map(),                          //选择对象Id
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    rowClick (row) {
      if (this.multiSelect) {
        let index = this.selections.findIndex((e) => {
          return e === row.id
        })
        if (index < 0) {
          this.selections.push(row.id)
          this.selectionMaps.set(row.id, {
            id: row.id,
            name: row.name
          })
        } else {
          this.selections.splice(index, 1)
          this.selectionMaps.delete(row.id)
        }
      } else {
        this.selectId = row.id
        this.selectionsChange(row.id)
      }
    },
    selectionsChange (selection) {
      this.selectName = ''
      let item = this.dataList.find(e => {
        return e.id === selection
      })
      if (item) {
        this.selectName = item.name
      }
    },
    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      this.tablePage.currentPage = 1
      this.onGetGoods()
    },
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.onGetGoods()
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.onGetGoods()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.onGetGoods()
      }
    },
    onGetGoods () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.title) {
        params.name = this.title
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }

      this.getGoods(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.url = child.link ? child.link.link || '' : ''
            child.status = '已发布'
            return child
          })
          this.tablePage.total = res.data.total || 0
        }
      })
    },

    onCancelClick () {
      this.$emit('cancel')
    },
    onOkClick () {
      let list = []
      if (this.multiSelect) {
        for (let [val] of this.selectionMaps) {
          list.push(this.selectionMaps.get(val))
        }
      } else {
        list = [{
          id: this.selectId,
          name: this.selectName
        }]
      }
      this.$emit('ok', list)
    },
    ...mapActions([
      'getGoods',
      'addGoods',
      'delGood'
    ])
  }
}
</script>

<style lang="scss" scoped>

</style>
